<template>
    <div class="my-orders">
        <h3 class="mb-3">My Orders</h3>

        <div v-if="loading">
            <content-placeholders>
                <content-placeholders-text :lines="5" />
            </content-placeholders>
        </div>
        <div v-else>
            <div v-show="allOrders && allOrders.length" role='tablist'>
                <div v-if="allOrders.length > ordersPerPage" class="row">
                    <div class="col">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="orders.length"
                            :per-page="ordersPerPage"
                        ></b-pagination>
                    </div>
                    <div class="col">
                        <b-input-group prepend="Search">
                            <b-input type="text" v-model="searchText" @input="searchOrders()"></b-input>
                        </b-input-group>
                    </div>
                </div>

                <div v-for="(order, index) in orderWindow" :key="index" class='card order' :class="{'large': order.items && order.items.length > 5}">

                    <h5 class="card-header d-flex" v-b-toggle="'card-' + index">
                        <div class="align-self-center mr-3">
                            {{order.date}} - {{order.shippingname}}
                            <span class="caret-down">
                                                <font-awesome-icon :icon="['fas', 'caret-down']" size="sm" />
                                            </span>
                            <span class="caret-up">
                                                <font-awesome-icon :icon="['fas', 'caret-up']" size="sm" />
                                            </span>
                        </div>
                        <div class="text-muted align-self-center ml-auto">
                            <!-- {{order.total | currency}} -->
                        </div>
                    </h5>

                    <b-collapse :id="'card-' + index">

                        <div class='card-body'>
                            <p class="mb-0"><strong>Email: </strong> {{order.email}}</p>
                            <p v-if="order.purchase_order"><strong>Purchase Order: </strong> {{order.purchase_order}}</p>

                            <div class="table-responsive">
                                <table class='table table-bordered table-striped mb-0'>
                                    <thead class="bg-secondary text-white">
                                    <tr>
                                        <th class="text-nowrap">Sku</th>
                                        <th class="text-nowrap">Name</th>
                                        <th class="text-nowrap">Unit Price</th>
                                        <th class="text-nowrap">Quanity</th>
                                        <th class="text-nowrap">Subtotal</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item, index) in order.items" :key="index">
                                        <td>{{item.sku}}</td>
                                        <td>{{item.name}}</td>
                                        <td>{{item.unit_price | currency}}</td>
                                        <td>{{item.quantity}}</td>
                                        <td>{{item.subtotal | currency}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="alert-warning p-3 row">
                                <div class="col-6">
                                    <label><strong>Shipping</strong></label>
                                    <div>{{order.shippingname}}</div>
                                    <div>{{order.shippingaddress}}</div>
                                    <div>{{order.shippingcity}}, {{order.shippingstate}} {{order.shippingzip}}</div>
                                </div>
                                <div class="col-6" v-if="order.shipping_status">
                                    <label><strong>Tracking</strong></label>
                                    <div>{{order.shipping_status.carrier}}</div>
                                    <div>{{order.shipping_status.tracking_number}}</div>
                                    <div v-if="order.shipping_status.delivery_status">{{order.shipping_status.delivery_status}}<span v-if="order.shipping_status.delivery_date"> - {{order.shipping_status.delivery_date}}</span></div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="d-flex">
                                <div class="ml-auto text-right">
                                    <div class="d-flex">
                                        <span class="text-muted mr-2">Subtotal</span>
                                        <span class="ml-auto">{{order.subtotal | currency}}</span>
                                    </div>
                                    <div class="d-flex">
                                        <span class="text-muted mr-2">Shipping</span>
                                        <span class="ml-auto">{{order.shipping | currency}}</span>
                                    </div>
                                    <div class="d-flex">
                                        <span class="text-muted mr-2">Total</span>
                                        <span class="ml-auto"><strong>{{order.total | currency}}</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>
                </div>
            </div>
            <div v-if="!orders || orders && !orders.length">
                <div class="alert alert-danger">
                    <!-- 0 orders -->
                    You do not have any orders
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.order + .order {
    margin-top: .25rem;
}
.order .card-header {
    cursor: pointer;
}
// .order:nth-child(even) .card-header {
//         background-color: rgba(0, 0, 0, 0.06);
// }
.order .caret-up {
    display: inline-block;
}
.order .collapsed .caret-up {
    display: none;
}
.order .caret-down {
    display: none;
}
.order .collapsed .caret-down {
    display: inline-block;
}

.order.large .table-responsive {
    max-height: 283px;
    overflow: scroll;
}

.order.large .table-responsive::-webkit-scrollbar {
    -webkit-appearance: none;
}

.order.large .table-responsive::-webkit-scrollbar:vertical {
    width: 11px;
}

.order.large .table-responsive::-webkit-scrollbar:horizontal {
    height: 11px;
}

.order.large .table-responsive::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
}
</style>

<script>

export default {
    data: () => ({
        cardPosition: 0,
        currentPage: 1,
        ordersPerPage: 10,
        allOrders: [],
        orders: [],
        totalReferred: 900,
        loading: false,
        searchText: "",
    }),
    computed: {
        storeCredit () {
            if (this.totalReferred <= 1800) {
                return this.totalReferred * .03
            }
            if (this.totalReferred <= 5400) {
                return (1800 * .03) + ((this.totalReferred - 1800) * .05)
            }
            return (1800 * .03) + (3600 * .05) + ((this.totalReferred - 5400 * .1))
        },
        orderWindow() {
            let min = (this.currentPage-1) * this.ordersPerPage;
            let max = min + this.ordersPerPage;
            let items = [];
            for (let i = min; i < max; ++i) {
                if (i >= this.orders.length)
                    break;

                items.push(this.orders[i]);
            }
            return items;
        }
    },
    methods: {
        getOrders () {
            this.loading = true

            this.$http({
                'url': `dashboard/orders`,
                'method': 'get'
            }).then((response) => {
                this.loading = false


                this.orders = response.data
                // this.orders.sort(function compare(a, b) {
                    // var dateA = new Date(a.date)
                    // var dateB = new Date(b.date)
                    // return dateA - dateB
                // });
                this.allOrders = this.orders;
            })
        },
        searchOrders() {
            if (!this.searchText) {
                this.orders = this.allOrders;
                return;
            }

            this.orders = this.allOrders.filter((order) => {
                return this.searchMatch(order.email, this.searchText)
                    || this.searchMatch(order.purchaseOrder, this.searchText)
                    || this.searchMatch(order.shippingname, this.searchText)
                    || this.hasMatchedItem(order);
            })

        },
        hasMatchedItem(order) {
            // Search order items for searchtext
            for (let i = 0; i < order.items.length; ++i) {
                if ( this.searchMatch(order.items[i].sku, this.searchText)
                    || this.searchMatch(order.items[i].name, this.searchText))
                    return true;
            }
            return false;
        },
        searchMatch(a, b) {
            if (!a || !b) return false;
            let aLower = a.toLowerCase();
            let bLower = b.toLowerCase();
            return aLower == bLower
                || aLower.includes(bLower);
        },
    },
    mounted () {
        this.getOrders()
    },
}
</script>
